import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from '../redux/store';
import { useIntercom } from 'react-use-intercom';
import { getIsLoggedIn, getJwt, getInstitutionId } from '../redux/slices/account';
import { storeUrlOnLogin } from '../redux/slices/navigation';
import { getUserNavigation } from '../redux/actions/navigation';

AuthGuard.propTypes = { children: PropTypes.node };

export default function AuthGuard({ children }) {
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const jwt = useSelector(getJwt);
  const institutionId = useSelector(getInstitutionId);
  const { shutdown } = useIntercom();
  const handledGuestLocation = useRef(null);

  useEffect(() => {
    if (!isLoggedIn || !jwt || !institutionId) return;
    dispatch(storeUrlOnLogin(null));
    const request = dispatch(getUserNavigation({ jwt, institutionId }));
    return () => request.abort();
  }, [dispatch, isLoggedIn, jwt, institutionId]);

  useEffect(() => {
    if (isLoggedIn) {
      handledGuestLocation.current = null;
      return;
    }
    const locationKey = pathname + search;
    if (handledGuestLocation.current === locationKey) return;
    handledGuestLocation.current = locationKey;
    const protectedPath = pathname !== '/auth' && pathname !== '/';
    dispatch(storeUrlOnLogin(protectedPath ? pathname : null));
    shutdown();
    // The application-level drawer provider owns OTP verification.
  }, [dispatch, isLoggedIn, pathname, search, shutdown]);

  if (!isLoggedIn) return <Navigate to="/auth" />;
  return <>{children}</>;
}
